import { schema } from 'normalizr';
import get from 'lodash/get';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const CREATE_FILTER_REQUEST = 'CREATE_FILTER_REQUEST';
export const CREATE_FILTER_SUCCESS = 'CREATE_FILTER_SUCCESS';
export const CREATE_FILTER_FAILURE = 'CREATE_FILTER_FAILURE';

function getArrayFilter(filter, name) {
  // only if it's an array filter then return the value
  if (get(filter, `${name}.operator`) === 'is_in') {
    return get(filter, `${name}.value`, []);
  }

  return [];
}

export const filterSchema = new schema.Entity(
  'filters',
  {},
  {
    idAttribute: 'address',
    processStrategy(filter) {
      return {
        // these values makes the UI backwards compatible with the old filter schema
        geographies: getArrayFilter(filter, 'properties.geographyId'),
        currencies: getArrayFilter(filter, 'properties.currency'),
        products: getArrayFilter(filter, 'properties.productId'),
        channels: getArrayFilter(filter, 'properties.channelId'),
        ...filter,
      };
    },
  },
);

function getPropertyFilter(formValues, name) {
  if (formValues[name] && formValues[name].length > 0) {
    return {
      operator: 'is_in',
      value: formValues[name],
    };
  }

  return undefined;
}

function createFilterPayload(formValues) {
  return {
    type: formValues.type,
    properties: {
      geographyId: getPropertyFilter(formValues, 'geographies'),
      currency: getPropertyFilter(formValues, 'currencies'),
      productId: getPropertyFilter(formValues, 'products'),
      channelId: getPropertyFilter(formValues, 'channels'),
    },
  };
}

/**
 * Returns a redux api middleware action that makes a request to create a filter.
 *
 * @param {object} values - New filter field values.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const createFilter = values =>
  createAction({
    endpoint: `${window.config.apiUrl}/filters`,
    method: 'POST',
    body: JSON.stringify(createFilterPayload(values)),
    types: [
      { type: CREATE_FILTER_REQUEST },
      {
        type: CREATE_FILTER_SUCCESS,
        payload: (action, state, res) => handleResponse(filterSchema, action, state, res),
      },
      { type: CREATE_FILTER_FAILURE, payload: handleError },
    ],
  });
